/*
 * 工具库
 * - cookie
 * - ticket: 登陆后返回的票据
 **/

const appConfig = require('@/config');

// cookie
export const Cookie = {
    get(name) {
        let arr;
        const reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
        if (arr = document.cookie.match(reg)) {
            return decodeURIComponent(arr[2]);
        } else {
            return null;
        }
    },
    set(name, value, time) {
        // 取时函数
        const getsec = str => {
            const str1 = str.substring(1, str.length) * 1;
            const str2 = str.substring(0, 1);
            let data = {
                s: str1 * 1000,
                h: str1 * 60 * 60 * 1000,
                d: str1 * 24 * 60 * 60 * 1000
            }
            return data[str2];
        };
        let cookie = ''
        if (!time) {
            const Days = 30;
            const exp = new Date();
            exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
            cookie = `${name}=${escape(value)};expires=${exp.toGMTString()};path=/;`
        } else {
            const strsec = getsec(time);
            const exp = new Date();
            exp.setTime(exp.getTime() + strsec * 1);
            cookie = `${name}=${encodeURIComponent(value)};expires=${exp.toGMTString()};path=/; `
        }
        if (!window.location.host.startsWith('localhost')) {
            cookie += 'domain=anjianba.cn;'
        }
        document.cookie = cookie
    },
    remove(name) {
        const exp = new Date();
        exp.setTime(exp.getTime() - 1);
        const cval = this.get(name);
        if (cval !== null) {
            let cookie = `${name}=${encodeURIComponent(cval)};expires=${exp.toGMTString()};path=/;`
            document.cookie = cookie
            if (!window.location.host.startsWith('localhost')) {
                let cookieWithDomain = cookie + 'domain=anjianba.cn;'
                document.cookie = cookieWithDomain
            }
        }
    }
};

export const Ticket = {

    set(value) {
        return Cookie.set("nsts_ticket", JSON.stringify(value), "d1");
    },
    get() {
        let ticket = Cookie.get("nsts_ticket");

        if (!ticket || ticket=='undefined' || ticket=='null') {
            this.remove()
            let pathname = location.pathname;
            if ((pathname != '/'  && pathname != '/login' && pathname != '/hrlogin')) {
                return this.backToLogin()
            }
            return {}
        }

        ticket = JSON.parse(ticket);

        if (isTokenExpired(ticket)) {
            $.ajax({
                url: `${appConfig.baseUrl}/login/refreshtoken`,
                type: 'POST',
                async: false,
                timeout: 10000,
                data: {
                    refreshToken: ticket.refresh_token,
                    version: appConfig.version
                },
            }).done(res => {
                let newTicket = res.package;

                ticket = newTicket;

                // 更新cookie中的票据
                this.set(newTicket);
            }).fail(_ => {
                return this.backToLogin()
            });
        }

        return ticket
    },
    remove() {
        return Cookie.remove("nsts_ticket");
    },
    backToLogin() {
        console.log('back to login!!')
        this.remove();
        window.location.href = "/login";
        return {}
    }
};

export function isTokenExpired(ticket) {
    let expiredTime = Number(ticket.start_date) + ticket.expires_in;
    let now = Math.floor(new Date().getTime() / 1000);
    //console.warn(`Token 还有${expiredTime - now}s 过期`)

    // 还有30s过期
    return (expiredTime - now < 30)
}

// localStorage
export const Storage = {
    storage: window.localStorage,

    set(item, value) {
        if (typeof value === "object") {
            value = JSON.stringify(value);
        }

        return this.storage.setItem(item, value);
    },
    get(item) {
        const itemStr = this.storage.getItem(item);

        if (itemStr) {
            try {
                return JSON.parse(itemStr)
            } catch(err) {
                return itemStr
            }

           // return JSON.parse(itemStr);
        } else {
            return null;
        }
    },
    remove(item) {
        return this.storage.removeItem(item);
    },
    clear() {
        return this.storage.clear();
    },
    keys() {
        let arr = [];
        for (let i = 0; i < window.localStorage.length; i++) {
            arr.push(window.localStorage.key(i));
        }
        return arr;
    }
};

// 函数节流
export const Throttle = function(func, wait) {
    var context, args, timeout, result;
    var previous = 0;
    var later = function() {
        previous = new Date;
        timeout = null;
        result = func.apply(context, args);
    };
    return function() {
        var now = new Date;
        var remaining = wait - (now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0) {
            clearTimeout(timeout);
            timeout = null;
            previous = now;
            result = func.apply(context, args);
        } else if (!timeout) {
            timeout = setTimeout(later, remaining);
        }
        return result;
    };
};

// 函数防抖
export const Debounce = function(func, wait, immediate) {
    var timeout, result;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) result = func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) result = func.apply(context, args);
        return result;
    };
};

//cascade组件，对接口的数据格式化处理
export const Cascade = {

    deleteEmptyChild(_arr) {
        let arr = _arr;

        arr.forEach(ele => {
            if (ele.children && ele.children.length) {
                this.deleteEmptyChild(ele.children)
            } else {
                delete ele.children;
            }
        });

        return arr;
    },

    /**
     * 通过id寻找它的完整路径
     * @param arr {Array}
     * @param id  {Number}
     * returns {Array}
     */
    fullPath(arr, id) {

        let rstArr = [];
        let matched = false;

        let loop = (arr, id, i = 0) => {
            for (let val of arr) {
                if (val.id === id) {
                    rstArr.push(val.id);
                    matched = true;
                    break;
                }

                if (val.children) {
                    loop(val.children, id, i++);
                    if (matched) {
                        rstArr.push(val.id);
                        break;
                    }
                }
            }
        };

        loop(arr, id);

        return rstArr.reverse();
    }
};

export const screenfull =  {
    fn: (function () {
        if (document.exitFullscreen) {
            return ['requestFullscreen', 'exitFullscreen']
        } else if (document.msExitFullscreen) {
            return ['msRequestFullscreen', 'msExitFullscreen']
        } else if (document.mozCancelFullScreen) {
            return ['mozRequestFullScreen', 'mozCancelFullScreen']
        } else if (document.webkitExitFullscreen) {
            return ['webkitRequestFullScreen', 'webkitExitFullscreen']
        }
    })(),
    request(dom = document.body) {
        dom[this.fn[0]]();
    },
    exit() {
        this.isFull() && document[this.fn[1]]();
    },
    isFull () {
        let isFull = window.fullScreen || document.webkitIsFullScreen || document.msFullscreenEnabled
        if (isFull === undefined) isFull = false
        return isFull
    }
};

/**
 *
 * @param {Number} time
 */
export function formatTime(time) {
    let minute = 0
    let second = 0
    if (time > 60) {
        minute = Math.floor(time / 60)
        second = time - minute * 60
    } else {
        second = time
    }
    minute = minute < 10 ? '0' + minute : minute
    second = second < 10 ? '0' + second : second
    return `${minute}:${second}`
}


/**
 *  精准倒计时组件
 *  用法：new CountDown(duration, onTick, onComplete)
 *  @param duration {Number}  倒计时,单位ms
 *  @param onTick  {Function} 每次倒计时的回调
 *  @param onTick  {Function} 倒计时完成的回调
 */
export class CountDown {
    constructor(duration, onTick, onComplete, options={}) {
        this.duration = duration
        this.onTick = onTick
        this.onComplete = onComplete
        this.interval = options.interval || 1000
        this._count = 0
        this._startTime = new Date().getTime()

        this.timeCounter = setTimeout(this._countDownStart.bind(this), this.interval)
    }
    _countDownStart() {
        this._count++;
        var offset = new Date().getTime() - (this._startTime + this._count * this.interval)
        var nextTime = this.interval - offset

        if (nextTime < 0) { nextTime = 0 }
        this.duration -= this.interval;

        //console.log("误差：" + offset + "ms，下一次执行：" + nextTime + "ms后，倒计时还剩：" + this.duration + "ms")

        if(this.duration <= 0){
            this.onComplete()
            clearTimeout(this.timeCounter)
        }else{
            this.onTick(this.duration)
            this.timeCounter = setTimeout(this._countDownStart.bind(this), nextTime)
        }
    }
    clear() {
        clearTimeout(this.timeCounter)
    }
}

// 是否为空，可以判断任意类型，包括null、undefined、number、string、array、object等
export function isEmpty(val) {
    // null or undefined
    if (val == null) return true;

    if (typeof val === 'boolean') return false;

    if (typeof val === 'number') return !val;

    if (val instanceof Error) return val.message === '';

    switch (Object.prototype.toString.call(val)) {
        // String or Array
        case '[object String]':
        case '[object Array]':
            return !val.length;

        // Map or Set or File
        case '[object File]':
        case '[object Map]':
        case '[object Set]':
        {
            return !val.size;
        }
        // Plain Object
        case '[object Object]':
        {
            return !Object.keys(val).length;
        }
    }

    return false;
}

// 深拷贝
export function deepClone(source) {
    if (!source && typeof source !== 'object') {
        throw new Error('error arguments', 'deepClone')
    }
    const targetObj = source.constructor === Array ? [] : {}
    Object.keys(source).forEach(keys => {
        if (source[keys] && typeof source[keys] === 'object') {
            targetObj[keys] = deepClone(source[keys])
        } else {
            targetObj[keys] = source[keys]
        }
    })
    return targetObj
}

// 由一个组件，向上找到最近的指定组件
export function findComponentUpward (context, componentName) {
    let parent = context.$parent;
    let name = parent.$options.name;

    while (parent && (!name || [componentName].indexOf(name) < 0)) {
        parent = parent.$parent;
        if (parent) name = parent.$options.name;
    }

    return parent;
}
